import { RouteRecordRaw } from 'vue-router';

export const waRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../pages/_layout/WaLayout.vue'),
    meta: { scope: 'wa', title: 'WMS Wareneingang' },
    children: [
      { path: '', name: 'wa.main', component: () => import('../pages/MainView.vue') },
      { path: 'verladen/:id', name: 'wa.verladen', component: () => import('../pages/VerladenView.vue'), props: (route) => ({ id: route.params.id }) },
      // { path: 'orders.dateien', name: 'edi.orders.dateien', component: () => import('../pages/orders/OrdersDateienView.vue') },
      // {
      //   path: 'orders.datei/:id',
      //   name: 'edi.orders.datei',
      //   component: () => import('../pages/orders/OrdersDateiDetailView.vue'),
      //   props: (route) => ({ id: route.params.id }),
      // },
      // { path: 'orders.transaktionen', name: 'edi.orders.transaktionen', component: () => import('../pages/orders/OrdersTransaktionenView.vue') },
      // {
      //   path: 'orders.transaktion/:id',
      //   name: 'edi.orders.transaktion',
      //   component: () => import('../pages/orders/OrdersTransaktionDetailView.vue'),
      //   props: (route) => ({ id: route.params.id }),
      // },
      // { path: 'desadv', name: 'edi.desadv', component: () => import('../pages/desadv/DesadvView.vue') },
      // {
      //   path: 'desadv/transaktion/:id',
      //   name: 'edi.desadv.transaktion',
      //   component: () => import('../pages/desadv/DesadvTransaktionDetailView.vue'),
      //   props: (route) => ({ id: route.params.id }),
      // },
      // { path: 'invoice/dateien', name: 'edi.invoice.dateien', component: () => import('../pages/invoices/InvoiceDateienView.vue') },
      // {
      //   path: 'invoice/datei/:id',
      //   name: 'edi.invoice.datei',
      //   component: () => import('../pages/invoices/InvoiceDateiDetailView.vue'),
      //   props: (route) => ({ id: route.params.id }),
      // },
      // { path: 'invoice/transaktionen', name: 'edi.invoice.transaktionen', component: () => import('../pages/invoices/InvoiceTransaktionenView.vue') },
      // {
      //   path: 'invoice/transaktion/:id',
      //   name: 'edi.invoice.transaktion',
      //   component: () => import('../pages/invoices/InvoiceTransaktionDetailView.vue'),
      //   props: (route) => ({ id: route.params.id }),
      // },
    ],
  },
];
